import { ESuggestionsActionTypes } from '../../actions/suggestions';
import { prepareSuggestions } from '../../mappers';
import { TReduxActions } from '../../types/redux';
import { ISuggestionsState } from '../../types/suggestions';

export const defaultState: ISuggestionsState = {
  isLoading: false,
  list: [],
};

export function suggestionsReducer(state = defaultState, action: TReduxActions) {
  switch (action.type) {
    case ESuggestionsActionTypes.Request: {
      return {
        isLoading: true,
        list: [],
      };
    }
    case ESuggestionsActionTypes.Success:
      return {
        isLoading: false,
        list: prepareSuggestions(action.payload),
      };
    case ESuggestionsActionTypes.Failure:
    case ESuggestionsActionTypes.Reset:
      return {
        isLoading: false,
        list: [],
      };
    default:
      return state;
  }
}
